const contractDev = {
    "1": "DG100",
    "3": "DG1K",
    "7": "DG001",
    "9": "DG1",
}
const contractProd = {
    "1": "DG100",
    "2": "DG1K",
    "4": "DG001",
    "5": "DG1",
}

const currentENV = process.env.NODE_ENV

export const contract = currentENV === "development" ? contractDev : contractProd

